
import Search from '@/components/Search'
export default {
  components: {
    Search
  },
  props: {
    screen:{
      type: Object,
      default: () => {}
    },
    id: {
      type: String
    },
    w: {
      type: String
    },
    y: {
      type: String
    },
    url: {
      type: Object,
    },
    buttonTitle: {
      type: String,
      default: '立即购买'
    },
    isoff: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      warehouses: [],
      data: {
        Name: '火星直营店 未知商品，默认被外星人抓走了？！',
        Price: 999999.99,
        ProductNo: 'No.00000000000000001',
        NewsShow: '<h1>未知商品，默认被外星人抓走了？！</h1>',
        Metering: '吨',
        StockAll: 100.00,
        EnterpriseName: '火星直营店',
        Images: []
      },

      loading: false,
      uploader: SZH.assets.api + "/Custom/PostQualityImage",
      GetCompanyItem: SZH.assets.api + '/Custom/GetSelectCompanyForCustom',
      CheckQualificationIsDue: SZH.assets.api + '/Custom/CheckQualificationIsDue',
      companyArr:[],
      comForm:{
        companyId:null
      },
    }
  },
  methods: {
    GetCompanyItemFun(){
      let self = this;
      self.$http.post(self.GetCompanyItem, {}).then(result => {
        if (result.state == true && result.data && result.data.length > 0) {
          self.companyArr = result.data;
          self.comForm.companyId = result.data[0].value
        } else {
          self.companyArr = [];
          self.comForm.companyId = '';
        }
      }, () => {
      });
    },
    getId(id){
      return id.replace(/[-]/g, '');
    },
    getImg(url) {
      return SZH.assets.image + url;
    },


    turnTo(url) {
      this.$router.push({
        path: url
      })
    },
    getPic(url) {
      return SZH.assets.image + url;
    },
    toFixed(num) {
      return parseFloat( num != null && num != undefined ? num.toFixed(2) : '0.00')
    },
    loadData() {
      var self = this;
      self.loading = true;
      self.$http.post(self.url.get, {
        ProductId: self.id,
      }).then(result => {
        if (result.state == true && result.data != null) {
          self.data = result.data;
        } else {
          self.data = {
            Name: '火星直营店 未知商品，默认被外星人抓走了？！',
            Price: 999999.99,
            ProductNo: 'No.00000000000000001',
            NewsShow: '<h1>未知商品，默认被外星人抓走了？！</h1>',
            Metering: '吨',
            StockAll: 100.00,
            EnterpriseName: '火星直营店',
            Id: self.id,
            Images: [],
          };
        }
        self.loading = false;
      }, () => {
        self.loading = false;
      });
    },
    onBuy(){

      var self = this;
      if(self.isoff){
        self.CheckQualificationIsDueFun();
      }else {
        if(!self.comForm.companyId){
          self.$message.error('请先进行企业认证');
          return
        }
        self.CheckQualificationIsDueFun();
      }


    },
    CheckQualificationIsDueFun(){
      let self = this;
      self.canBuyLast();
      // self.$router.push({
      //   path: '/Menu/order',
      //   query:{n:self.data.Name,CompanyId:self.comForm.companyId,y:self.y}
      // })

    },
    canBuyLast(){
      let self = this;
      self.$http.post(self.url.canBuy, {
        ProductId: self.id,
        CompanyId: self.comForm.companyId,
      }).then(result => {
        if (result.state == true && result.data != null) {
          if(result.data.BuyQualification == 0) {
            sessionStorage.setItem("orderFormId", self.id);
            sessionStorage.setItem("isThrid", self.isoff);
            self.$router.push({
              path: '/Menu/order',
              query:{n:self.data.Name,CompanyId:self.comForm.companyId,y:self.y}
            })
          }
          else if(result.data.BuyQualification == 1) {
            this.$alert('很抱歉，本产品为限定产品，如需购买，请与您的业务员进行联系，谢谢！', '无法购买', {
              confirmButtonText: '确定',
              type: 'error',
              center: true,
              callback: action => {
              }
            });
          }
          else {
            this.$alert('很抱歉，您需要上传' + result.data.QualificationName + '！请联系您的业务员', '需要上传资质', {
              confirmButtonText: '确定',
              type: 'error',
              center: true,
              callback: action => {
                self.$router.push('/My/userInfo');
              }
            });
            if(false) {
              self.qualificationName = result.data.QualificationName;
              self.qualifications = result.Data.Qualifications;
              for(var i in self.qualifications) {
                var q = self.qualifications[i];
                if(typeof(q) != 'function') {
                  q.testImg = '';
                }
              }
              self.dialogVisible = true;
            }
          }
        } else {
          if(result) {
            self.data.CanBuy = false;
            if(result.message.indexOf('不可重复下单')>-1){
              this.$alert(result.message, '无法购买', {
                confirmButtonText: '去订单列表',
                type: 'error',
                center: true,
                callback: action => {
                  self.$router.push('/My/OrderList');
                }
              });
            }else{
              this.$alert(result.message, '无法购买', {
                confirmButtonText: '确定',
                type: 'error',
                center: true,
                callback: action => {
                }
              });
            }
          }
        }
        // self.loading = false;
      }, () => {
        // self.loading = false;
      });
    }
  },
  computed: {

    imageHeight() {
      return this.isPhone ? this.screen.width + 'px' : '360px';
    }
  },
  created() {
  },
  mounted() {
    this.loadData();
    this.GetCompanyItemFun();

  },
  watch: {}
}



// WEBPACK FOOTER //
// ./src/components/Detail/detail.js